import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { toast } from "sonner";
import http from "@/lib/http";

const usePageContentStore = create(
  devtools((set) => ({
    landingPage: null,
    landingPageLoading: false,
    landingPageError: null,

    carbonPage: null,
    carbonPageLoading: false,
    carbonPageError: null,

    benifitPage: null,
    benifitPageLoading: false,
    benifitPageError: null,

    contactPage: null,
    contactPageLoading: false,
    contactPageError: null,

    rlcnPage: null,
    rlcnPageLoading: false,
    rlcnPageError: null,

    blogPage: null,
    blogPageLoading: false,
    blogPageError: null,
    
    privacyPage: null,
    privacyPageLoading: false,
    privacyPageError: null,

    fulfillmentPage: null,
    fulfillmentPageLoading: false,
    fulfillmentPageError: null,

    // --- Added Footer State ---
    footerPage: null,
    footerPageLoading: false,
    footerPageError: null,
    // --- End Added Footer State ---


    fetchLandingPage: async () => {
      set({ landingPageLoading: true, landingPageError: null });

      try {
        const { data } = await http.get("/public/pages/landing-page");
        set({
          landingPage: data?.data || null,
          landingPageLoading: false,
        });
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || "Failed to load landing page";
        set({ landingPageError: errorMessage, landingPageLoading: false }); // Corrected 'loading' to 'landingPageLoading'
        toast.error(errorMessage);
      }
    },
    fetchBinifitPage: async () => {
      set({ benifitPageLoading: true, benifitPageError: null });

      try {
        const { data } = await http.get("/public/pages/benifits");
        set({
          benifitPage: data?.data?.benifits || null,
          benifitPageLoading: false,
        });
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || "Failed to load benifit";
        set({ benifitPageError: errorMessage, benifitPageLoading: false }); // Corrected 'loading' to 'benifitPageLoading'
        toast.error(errorMessage);
      }
    },
    fetchContactPage: async () => {
      set({ contactPageLoading: true, contactPageError: null });
      try {
        const { data } = await http.get("/public/pages/contact-details");
        set({
          contactPage: data?.data || null,
          contactPageLoading: false,
        });
      } catch (error) {
        let errorMessage =
          error?.response?.data?.error || "Failed to load contact details"; // More specific message
        set({ contactPageError: errorMessage, contactPageLoading: false }); // Corrected 'loading' to 'contactPageLoading'
        toast.error(errorMessage);
      }
    },
    fetchCarbonPage: async () => {
      set({ carbonPageLoading: true, carbonPageError: null });
      try {
        const { data } = await http.get("/public/pages/carbon-page");
        set({
          carbonPage: data?.data || null,
          carbonPageLoading: false,
        });
      } catch (error) {
        let errorMessage =
          error?.response?.data?.error || "Failed to load carbon page"; // More specific message
        set({ carbonPageError: errorMessage, carbonPageLoading: false }); // Corrected 'loading' to 'carbonPageLoading'
        toast.error(errorMessage);
      }
    },
    fetchRlcnPage: async () => {
      set({ rlcnPageLoading: true, rlcnPageError: null });
      try {
        const { data } = await http.get("/public/pages/rlcn-page");
        set({
          rlcnPage: data?.data || null,
          rlcnPageLoading: false,
        });
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || "Failed to load RLCN page";
        set({ rlcnPageError: errorMessage, rlcnPageLoading: false });
        toast.error(errorMessage);
      }
    },
    fetchBlogPage: async () => {
      set({ blogPageLoading: true, blogPageError: null });
      try {
        const { data } = await http.get("/public/pages/blog-page");
        set({
          blogPage: data?.data || null,
          blogPageLoading: false,
        });
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || "Failed to load Blog page content";
        set({ blogPageError: errorMessage, blogPageLoading: false });
        toast.error(errorMessage);
      }
    },
    fetchPrivacyPage: async () => {
        set({ privacyPageLoading: true, privacyPageError: null });
        try {
            const { data } = await http.get("/public/pages/privacy-page");
            set({
                privacyPage: data?.data || null,
                privacyPageLoading: false,
            });
        } catch (error) {
            const errorMessage = 
                error?.response?.data?.error || "Failed to load Privacy Policy page";
            set({ privacyPageError: errorMessage, privacyPageLoading: false });
            toast.error(errorMessage);
        }
    },

    fetchFulfillmentPage: async () => {
      set({ fulfillmentPageLoading: true, fulfillmentPageError: null });
      try {
          const { data } = await http.get("/public/pages/fulfillment-page");
          set({
              fulfillmentPage: data?.data || null,
              fulfillmentPageLoading: false,
          });
      } catch (error) {
          const errorMessage = 
              error?.response?.data?.error || "Failed to load Fulfillment Policy page";
          set({ fulfillmentPageError: errorMessage, fulfillmentPageLoading: false });
          toast.error(errorMessage);
      }
    },

    // --- Added Footer Fetch Function ---
    fetchFooterPage: async () => {
        set({ footerPageLoading: true, footerPageError: null });
        try {
            const { data } = await http.get("/public/pages/footer");
            set({
                footerPage: data?.data || null,
                footerPageLoading: false,
            });
        } catch (error) {
            const errorMessage = 
                error?.response?.data?.error || "Failed to load Footer content";
            set({ footerPageError: errorMessage, footerPageLoading: false });
            toast.error(errorMessage);
        }
    },
    // --- End Added Footer Fetch Function ---
  })),
);

export default usePageContentStore;